import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Tooltip, TextField, IconButton, InputAdornment } from '@mui/material';
import Iconify from './Iconify';

type Props = {
  value: string;
};

export default function CopyClipboard({ value, ...other }: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const [state, setState] = useState({
    value,
    copied: false,
  });

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setState({ value: event.target.value, copied: false });
  };

  const onCopy = () => {
    setState({ ...state, copied: true });
    if (state.value) {
      enqueueSnackbar('Copied!');
    }
  };

  return (
    <TextField
      fullWidth
      value={state.value}
      onChange={handleChange}
      disabled
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <CopyToClipboard text={state.value} onCopy={onCopy}>
              <Tooltip title='Copy'>
                <IconButton>
                  <Iconify icon={'charm:copy'} width={24} height={24} />
                </IconButton>
              </Tooltip>
            </CopyToClipboard>
          </InputAdornment>
        ),
      }}
      {...other}
    />
  );
}
